import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Parking(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M21 12a9 9 0 11-18 0 9 9 0 0118 0zm2 0c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11zM10 7a1 1 0 00-1 1v8a1 1 0 102 0v-2h1.5c.697 0 1.548-.228 2.247-.782C15.48 12.635 16 11.724 16 10.5s-.52-2.135-1.253-2.718A3.694 3.694 0 0012.5 7H10zm3.503 4.651c-.301.24-.7.349-1.003.349H11V9h1.5c.303 0 .702.11 1.003.349.266.211.497.55.497 1.151s-.23.94-.497 1.151z",
    clipRule: "evenodd"
  }));
}

export default Parking;